import Vue from 'vue'
import Vuex from 'vuex'
import http from '../axios'
Vue.use(Vuex)

const store = new Vuex.Store({
  state: {
    title: '',
    info: {},
    user_info: {
      certification: {
        identity_auth_status: '',
        address_auth_status: ''
      }
    }
  },
  mutations: {
    set_info(state, info) {
      state.info = info
    },
    set_user_info(state, user_info) {
      state.user_info = user_info
    },
    set_title(state, title) {
      state.title = title
    }
  },
  actions: {
    initInfo({ commit, dispatch }) {
      return http.get('/user/info').then(res => {
        commit('set_info', res)
      })
    },

    initUserInfo({ commit, dispatch }) {
      return http.get('/user/index').then(res => {
        commit('set_user_info', res)
      })
    }
  }
})

window.vuex_store = store

export default store
